<template>
    <div class="nr_container_content mt-60 ">

        <v-modal-contents ref="modal_contents_successfully" class="modal_contents_successfully ">
            <template v-slot:close>
                <span></span>
            </template>
            <template v-slot:title>
                <div class="terms_of_use__title">
                    <div class="h2_title h2_title--modal">Ваши ответы приняты</div>
                </div>
            </template>
            <template v-slot:content>
                <div class="terms_of_use">
                    <p class="green_messs">Благодарим вас за уделенное время</p>

                    <a href="/" class="mt-4 btn v-btn btn_poll">Хорошо</a>
                </div>
            </template>
        </v-modal-contents>

        <v-modal-contents ref="modal_alert" class="modal_alert" style="width: 500px">
            <template v-slot:close>
                <!-- Крестик скрыт, так как слот пустой -->
                <span></span>
            </template>

            <template v-slot:title>
                <div class="terms_of_use__title">
                    <div class="h2_title h2_title--modal">Пожалуйста, заполните обязательные поля</div>
                </div>
            </template>

            <template v-slot:content>
                <div class="terms_of_use">
                    <v-btn class="mt-4 btn_poll" @click.prevent="closeAlertModal">
                        Хорошо
                    </v-btn>
                </div>
            </template>
        </v-modal-contents>

        <v-form ref="form" v-model="valid" class="poll" :class="validAll ? 'valid':'noValid'">
            <!-- 1. Данные о компании -->
            <v-text-field class="mb-20"
                          v-model="companyName"
                          label="1. Название вашей компании *"
                          :rules="rulesField"
                          required
            ></v-text-field>

            <!-- 2. Данные о контактном лице -->
            <v-text-field
                    class="mb-20"
                    v-model="contactPerson"
                    label="2. Имя и фамилия *"
                    :rules="rulesField"
                    required
            ></v-text-field>

            <!-- 3. Контактные данные -->
            <v-text-field
                    class="mb-20"
                    v-model="email"
                    label="3. Электронная почта *"
                    :rules="emailRules"
                    required
                    type="email"
            ></v-text-field>

            <!-- 4. Сроки поставки  -->
            <v-radio-group
                    v-model="deliveryTimes"
                    label="4.	Насколько вы удовлетворены сроками поставки товара (с учётом производства и логистики) с момента размещения заказа? "
            >
                <v-radio v-for="n in 10" :key="'quality-'+n" color="red" :label="String(n)"
                         :value="String(n)"></v-radio>
            </v-radio-group>

            <!-- 5. качество поставляемой продукции -->
            <v-radio-group
                    v-model="productQuality"
                    label="5.	Насколько вы удовлетворены качеством поставляемой продукции? от 1 до 10, где 1 – не удовлетворён, 10 – полностью удовлетворен)"
            >
                <v-radio v-for="n in 10" :key="'next-'+n" color="red" :label="String(n)" :value="String(n)"></v-radio>
            </v-radio-group>

            <!-- 6. внешний вид упаковки (1-10) -->
            <v-radio-group
                    v-model="packagingAppearance"
                    label="6.	Насколько вы удовлетворены внешним видом упаковки? (от 1 до 10, где 1 – не удовлетворён, 10 – полностью удовлетворен)"
            >
                <v-radio v-for="n in 10" :key="'satisf-'+n" color="red" :label="String(n)" :value="String(n)"></v-radio>
            </v-radio-group>

            <!-- 7. качество оформления документов  -->
            <v-radio-group
                    v-model="documentQuality"
                    label="7.	Насколько вы удовлетворены качеством оформления документов по поставке? (от 1 до 10, где 1 – не удовлетворён, 10 – полностью удовлетворен)"
            >
                <v-radio v-for="n in 10" :key="'rec-'+n" color="red" :label="String(n)" :value="String(n)"></v-radio>
            </v-radio-group>

            <!-- 8. расхождения по количеству или ассортименту  -->
            <v-radio-group
                    v-model="discrepancies"
                    label="8.	Как часто у вас возникали расхождения по количеству или ассортименту поставляемого товара (пересорт, излишек, недовоз)? (от 1 до 10, где 1 – постоянно, 10 – никогда)"
            >
                <v-radio v-for="n in 10" :key="'rec-'+n" color="red" :label="String(n)" :value="String(n)"></v-radio>
            </v-radio-group>

            <!-- 9. текущий ассортимент -->
            <v-radio-group
                    v-model="currentProducts "
                    label="9.	Насколько вас устраивает текущий ассортимент, предлагаемый нашей компанией? (от 1 до 10, где 1 — много позиций отсутствует, 10 — есть всё необходимое) "
            >
                <v-radio v-for="n in 10" :key="'rec-'+n" color="red" :label="String(n)" :value="String(n)"></v-radio>
            </v-radio-group>

            <!-- 10. Предложения по ассортименту -->
            <v-textarea
                    placeholder="Ваш ответ..."
                    color="red"
                    label="10. Какие дополнительные категории товаров или конкретные позиции вы хотели бы видеть в нашем ассортименте? "
                    v-model="productRangeProposals"
                    required
                    rows="1"
                    auto-grow
            ></v-textarea>

            <!-- 11. Оцените работу сотрудника -->
            <v-radio-group
                    v-model="serviceQuality"
                    label="11.	Оцените работу сотрудника отдела продаж с точки зрения качества обслуживания (от 1 до 10, где 1 — крайне недоволен, 10 — полностью доволен)"
            >
                <v-radio v-for="n in 10" :key="'rec-'+n" color="red" :label="String(n)" :value="String(n)"></v-radio>
            </v-radio-group>

            <!-- 12. Предложения по улучшению -->
            <v-textarea
                    placeholder="Ваш ответ..."
                    color="red"
                    v-model="improvementSuggestions"
                    label="12.	Ваши предложения по улучшению нашей работы/продукции "
                    required
                    rows="1"
                    auto-grow
            ></v-textarea>

            <v-btn class="mt-30 btn-red" @click.prevent="submitSurvey" color="#FA4237">Отправить</v-btn>
        </v-form>

    </div>
</template>

<script>
import VModalContents from "./modal_contents.vue";

export default {
    name: 'chemicalPolls',
    components: {VModalContents},
    props: {
        r: [String, Number, Boolean],
    },
    data() {
        return {
            valid: false,
            validAll: true,

            // Новые поля
            companyName: "",
            contactPerson: "",
            position: '',
            email: "",
            deliveryTimes: null,
            productQuality: null,
            packagingAppearance: null,
            documentQuality: null,
            discrepancies: null,
            currentProducts: null,
            productRangeProposals: '',
            serviceQuality: null,
            improvementSuggestions: '',

            // Валидация
            rulesField: [
                (v) => !!v || "Поле обязательно для заполнения",
                (v) => (v && String(v).length >= 1) || "Поле не может быть пустым",
            ],
            emailRules: [
                (v) => !!v || "Поле обязательно для заполнения",
                (v) => /.+@.+\..+/.test(v) || "Введите корректную электронную почту",
            ],
            textareaRules: [
                (v) => !!v || "Поле обязательно для заполнения",
                (v) => (v && String(v).length >= 10) || "Минимум 10 символов",
            ],
        };
    },
    methods: {
        submitSurvey() {
            if (!this.$refs.form.validate()) {
                this.validAll = false;
                this.$refs.modal_alert.modal_open();
                return;
            }
            this.validAll = true;

            const params = new URLSearchParams();
            const surveyData = {
                companyName: this.companyName,
                contactPerson: this.contactPerson,
                position: this.position,
                email: this.email,
                deliveryTimes: this.deliveryTimes,
                productQuality:this.productQuality,
                packagingAppearance: this.packagingAppearance,
                documentQuality: this.documentQuality,
                discrepancies: this.discrepancies,
                currentProducts: this.currentProducts,
                productRangeProposals: this.productRangeProposals,
                serviceQuality: this.serviceQuality,
                improvementSuggestions: this.improvementSuggestions,

                r: this.r,
            };

            params.set("ajaxPost", "Y");
            params.set("surveyData", JSON.stringify(surveyData));

            // Обращение 43208: ответы сохраняются в HL-блок ClientsSurveyChemical2026
            const url = "/ajax/polls_chemical_2026.php";
            fetch(url, {method: "POST", body: params})
                .then((response) => response.json().then((data) => ({ok: response.ok, data})))
                .then(({ok, data}) => {
                    if (!ok || !data.success) {
                        throw new Error(data.error || "Не удалось отправить ответы");
                    }
                    this.$refs.form.reset();
                    this.$refs.modal_contents_successfully.modal_open();
                })
                .catch((error) => {
                    console.error("Ошибка при отправке опроса:", error);
                    alert("Не удалось отправить ответы. Попробуйте ещё раз.");
                });
        },

        closeAlertModal() {
            this.$refs.modal_alert.modal_open();
        }
    },
};
</script>

<style class="scss">
.wrapp_multiply {
    margin-top: 38px;
}

/*h2.modal_alert__title {*/
/*    font-size: 20px !important;*/
/*}*/


.poll .v-input.error--text .v-text-field__slot label {
    color: #ff5252 !important;
}

.poll .v-input.error--text .v-input--radio-group legend.v-label {
    color: #ff5252 !important;
}


.poll .v-label.error--text {
    color: #ff5252 !important;
}

.noValid .noValidError {
    color: #ff5252 !important;
}

</style>

<style scoped>
.poll {
    margin-bottom: 80px;

    .different_el.v-input--is-focused,
    .different_el.v-input--is-label-active {
        margin-top: 18px;
    }

    .checkbox_group {
        .v-text-field.different_el {
            margin-top: 18px;
        }

        .different_el.v-input--is-focused,
        .different_el.v-input--is-label-active {
            margin-top: 25px;
        }
    }

    .v-text-field.different_el {
        padding-top: 0;
    }

    label.v-label.theme--light {
        margin-bottom: 0;
    }

    .v-input--checkbox .v-messages.theme--light {
        display: none;
    }

    .v-input--selection-controls.v-input--checkbox {
        margin-top: 4px;
        padding-top: 4px;
    }

    & .theme--light.v-input, .theme--light.v-input input, .theme--light.v-input textarea {
        color: #282828 !important;
    }

    &.v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
        margin: 0;

    }

    & .v-input--radio-group legend.v-label {
        font-family: 'MuseoSansCyrl-500';
        font-size: 20px !important;
        font-weight: 500;
        color: #282828;

        @media (max-width: 500px) {
            font-size: 16px !important;
        }
    }

    & .v-text-field .v-label {
        font-family: 'MuseoSansCyrl-500';
        font-size: 20px !important;
        font-weight: 500;
        color: #282828 !important;
        display: contents;
        white-space: unset;

        @media (max-width: 500px) {
            white-space: break-spaces;
            font-size: 16px !important;
        }
    }

    & .v-text-field .v-label.v-label--active {
        transform: translateY(-24px) scale(0.75) !important;
        display: block;
        white-space: nowrap;
    }

    & .theme--light.v-icon {
        color: #282828;
    }

    & .v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
        font-family: 'MuseoSansCyrl-500';
        font-size: 20px !important;
        color: #282828;

        @media (max-width: 500px) {
            font-size: 16px !important;
        }
    }

    & .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
        display: block;
    }

    & .v-messages__message {
        font-size: 15px !important;
    }

    & .v-input input {
        max-height: 46px;
    }
}

.mb-20 {
    margin-bottom: 20px;
}

.btn-red {
    padding: 28px 24px !important;
}

.btn_poll {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 22px 24px !important;
    background: #FA4237 !important;
    border-radius: 32px !important;
    font-family: "MuseoSansCyrl-500";
    font-size: 20px !important;
    line-height: 20px;
    letter-spacing: -0.05px;
    vertical-align: middle;
    color: #FFFFFF !important;
    box-shadow: none !important;
    text-transform: unset;
    transition: all 0.2s ease;
    width: max-content;
    height: 56px !important;
    transition: all 0.2s ease;

    &:hover {
        background: #CF2B21 !important;
    }
}
</style>